import React, { useEffect } from 'react';
import { ErrorRender, GenericError, Loading, loadingBox } from "../../../components/common";
import Page from "../../../components/Page/Page";
import { useModificationTripInfo } from "../../../providers/Modification";
import { trackingEvents, trackLabelTypes } from "../../../tracking/Modification/trackingEventsLC";
import { escalationRoutes } from "../../../types/routes";
import { trackingLCModification, funnelTypes } from "../../../tracking/Modification/trackingPage";
import { useBookingAdminRouter, useGetTokenFromUrl, useTrackModificationPage } from "../../../clientState/hooks";
import { useTracking } from '@edreamsodigeo/frontend-core';
import FlightSelectorLCMobilePage from "./components/FlightSelectorLCMobilePage";
import FlightSelectorLCDesktopPage from "./components/FlightSelectorLCDesktopPage";
import { useModificationProcessability } from "../../../providers/Modification/ModificationProcessabilityProvider";
import { useMmbMenuNavigation } from "../../../providers/MmbMenuNavigationProvider";
const FlightSelectorLCPage = () => {
  const token = useGetTokenFromUrl();
  const {
    loading,
    errors,
    bookingId,
    isPrime,
    legs
  } = useModificationTripInfo();
  const {
    navigateToMmbMenu
  } = useMmbMenuNavigation();
  const {
    modifiable,
    loading: loadingProcessability,
    error: errorProcessability
  } = useModificationProcessability();
  const {
    trackPage
  } = useTrackModificationPage();
  const {
    trackEvent
  } = useTracking();
  const {
    navigateToWithToken,
    back
  } = useBookingAdminRouter();
  const onClickMainButtonError = () => {
    window.location.reload();
  };
  const ErrorComponent = () => /*#__PURE__*/React.createElement(GenericError, {
    onClickMainButton: onClickMainButtonError
  });
  const loadingComponents = [loadingBox(), ...Array(6).map((_, index) => loadingBox({
    height: '60px',
    key: index
  }))];
  const onClickLink = () => {
    trackEvent(trackingEvents.CLICK_FLIGHT_SELECTOR(trackLabelTypes.openEF));
    navigateToWithToken(escalationRoutes.categories);
  };
  const onClickBackMenu = () => {
    trackEvent(trackingEvents.CLICK_FLIGHT_SELECTOR(trackLabelTypes.backToMenu));
    navigateToMmbMenu(token);
  };
  const onClickBack = () => {
    trackEvent(trackingEvents.CLICK_FLIGHT_SELECTOR(trackLabelTypes.back));
    back();
  };
  useEffect(() => {
    if (!loading && !errors && !loadingProcessability && !errorProcessability) {
      trackPage(`${trackingLCModification.basePath}/${trackingLCModification.flightSelectorLC}/${funnelTypes.lc}`);
    }
  }, [errorProcessability, errors, loading, loadingProcessability, trackPage]);
  const params = {
    bookingId,
    isPrime,
    legs,
    modifiable,
    onClickLink,
    onClickBack,
    onClickBackMenu
  };
  return /*#__PURE__*/React.createElement(ErrorRender, {
    error: Boolean(errors) || Boolean(errorProcessability),
    errorComponent: ErrorComponent
  }, /*#__PURE__*/React.createElement(Loading, {
    loading: loading || loadingProcessability,
    loadingComponents: loadingComponents
  }, /*#__PURE__*/React.createElement(Page, null, /*#__PURE__*/React.createElement(FlightSelectorLCMobilePage, params), /*#__PURE__*/React.createElement(FlightSelectorLCDesktopPage, params))));
};
export default FlightSelectorLCPage;